/*globals $ */

class StickyProductNav {
  constructor(mainApp) {
    this.mainApp = mainApp;
    this.$container = $('.StickyProductNav');
    this.$btns = [];
    this.prevMenuIndex = -1;
    // this.currentContent = 0;
    this.currentMenuIndex = -1;
    this.$cards = [];
    this.isShowNav = false;

    this.$navFadeinPosition = $('.FadeinNavPosition');

    $('.ProductNavItem').each((i, e) => {
      this.$btns.push($(e));
    });

    $('.Card--product').each((i, e) => {
      this.$cards.push($(e));
    });

    /*
    $('.StickyProductNav__scroller').on('scroll', () => {
      console.log($('.StickyProductNav__scroller').scrollLeft());
    });
    */
  }

  onWindowScroll(scrollTop) {
    this.scrollTop = scrollTop;

    if(this.scrollTop > this.$navFadeinPosition.offset()['top'] - 300) {
      if(!this.isShowNav) {
        this.mainApp.canMoveHeader = false;
        this.mainApp.canMoveSpHeader = false;
        this.isShowNav = true;
        this.$container.addClass('StickyProductNav--fadein');
      }
    } else {
      if(this.isShowNav) {
        this.mainApp.canMoveHeader = true;
        this.mainApp.canMoveSpHeader = true;
        this.isShowNav = false;
        this.$container.removeClass('StickyProductNav--fadein');
      }
    }

    let tmpIndex = -1;
    for(let i = 0; i < 10; i++) {
      if(this.scrollTop >= this.$cards[9 - i].offset()['top'] - 300) {
        tmpIndex = 9 - i;
        break;
      }
    }
    this.setMenuPosition(tmpIndex);
  }

  setMenuPosition(target) {
    let currentBtn = undefined;

    if(this.prevMenuIndex != target) {
      this.currentMenuIndex = target;

      if(target == -1) {
        for(let i = 0; i < this.$btns.length; i++) {
          this.$btns[i].removeClass('ProductNavItem--current');
        }
      } else {
        for(let i = 0; i < this.$btns.length; i++) {
          if(i == target) {
            this.$btns[i].addClass('ProductNavItem--current');
            currentBtn = this.$btns[i];
          } else {
            this.$btns[i].removeClass('ProductNavItem--current');
          }
        }
      }

      if(this.mainApp.viewMode == 'sp' && target != -1) {
        if(0 < currentBtn.offset()['left'] && currentBtn.offset()['left'] < this.mainApp.windowWidth - 28) {
          // console.log('画面内にボタンがある状態');
        } else {
          let targetLeft = currentBtn.position()['left'];
          $('.StickyProductNav__scroller').stop(false).animate({'scrollLeft': targetLeft}, 300, 'easeInOutSine');
        }
      }

    }
    this.prevMenuIndex = target;

  }

  onWindowResize() {
    // console.log(this.mainApp.viewMode);
  }
}

export default StickyProductNav;
